var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-wrap"},[_c('div',{staticClass:"block-hd"},[_vm._v(_vm._s(_vm.blockName))]),_c('div',{staticClass:"block-bd"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }